import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const self = this
    this.element.querySelectorAll('input[type="checkbox"]').forEach((el) => {
      el.addEventListener('change', () => self.submit())
    })
  }

  submit() {
    this.element.submit()
  }
}
